import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router';

import { appRoutes } from '@/app/router/routes';
import { PixelContainer } from '@/ui/pixel/PixelContainer';
import { useThemeColors } from '@/settings/handler/settingsStore';

export function NotFoundScreen() {
  const { t } = useTranslation();
  const colors = useThemeColors();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const showPath = pathname && pathname !== '/';

  return (
    <div className="flex h-full items-center justify-center px-8" style={{ backgroundColor: colors.surface }}>
      <div className="flex max-w-sm flex-col items-center">
        <h1 className="leading-none" style={{ fontSize: 52, color: colors.onSurface }}>
          {t('appName')}
        </h1>
        <h2 className="mt-7 text-center leading-tight" style={{ fontSize: 28, color: colors.onSurface }}>
          {t('notFoundTitle')}
        </h2>
        <p
          className="mt-3 text-center"
          style={{ fontSize: 14, lineHeight: 1.4, color: colors.onSurface, opacity: 0.7 }}
        >
          {t('notFoundMessage')}
        </p>
        {showPath ? (
          <p
            className="mt-2 text-center"
            style={{ fontSize: 12, lineHeight: 1.3, color: colors.onSurface, opacity: 0.45 }}
          >
            {pathname}
          </p>
        ) : null}
        <div className="mt-8">
          <PixelContainer
            radius={9}
            pixelScale={2}
            padding="14px 28px"
            backgroundColor={colors.surfaceContainerHighest}
            borderColor={colors.surfaceContainerHighest}
            onClick={() => navigate(appRoutes.home, { replace: true })}
          >
            <span className="leading-none" style={{ fontSize: 22, color: colors.onSurface }}>
              {t('notFoundCta')}
            </span>
          </PixelContainer>
        </div>
      </div>
    </div>
  );
}
